import { watchEffect } from 'vue'
import { useLicense } from '@/composables/useLicense'
import store from '@/store'

const { hasLicense, showLicensePrompt } = useLicense()

function setupLock(el, binding) {
    const isObject = binding.value && typeof binding.value === 'object'
    const featureName = isObject ? binding.value.feature : binding.value
    const iconColor = isObject ? (binding.value.iconColor || '#000000') : '#000000'

    if(!featureName || hasLicense(featureName)){
        cleanupLock(el)
        return
    }

    if(el.__licenseLocked) return

    el.style.opacity = '0.7'
    el.style.cursor = 'not-allowed'

    const lockIcon = document.createElement('span')
    lockIcon.innerHTML = `<i class="fas fa-lock" style="color: ${iconColor}"></i>`
    lockIcon.style.marginLeft = '8px'
    lockIcon.style.display = 'inline-flex'
    lockIcon.style.alignItems = 'center'
    lockIcon.style.fontSize = '14px'
    lockIcon.style.flexShrink = '0'
    el.appendChild(lockIcon)
    el.__licenseLockIcon = lockIcon

    const handler = (e) => {
        e.preventDefault()
        e.stopImmediatePropagation()
        showLicensePrompt()
    }
    el.addEventListener('click', handler, true)
    el.__licenseClickHandler = handler
    el.__licenseLocked = true
}

function cleanupLock(el) {
    if(!el.__licenseLocked) return

    el.style.opacity = ''
    el.style.cursor = ''

    if(el.__licenseLockIcon){
        el.__licenseLockIcon.remove()
        el.__licenseLockIcon = null
    }

    if(el.__licenseClickHandler){
        el.removeEventListener('click', el.__licenseClickHandler, true)
        el.__licenseClickHandler = null
    }

    el.__licenseLocked = false
}

export default {
    mounted(el, binding) {
        setupLock(el, binding)

        const stop = watchEffect(() => {
            // rendre la directive réactive aux changements du store licenses
            store.getters['license/licenses']
            cleanupLock(el)
            setupLock(el, binding)
        })

        el.__licenseWatchStop = stop
    },

    updated(el, binding) {
        const featureName = binding.value && typeof binding.value === 'object' ? binding.value.feature : binding.value
        const oldFeatureName = binding.oldValue && typeof binding.oldValue === 'object' ? binding.oldValue.feature : binding.oldValue
        if(featureName !== oldFeatureName || hasLicense(featureName) !== !el.__licenseLocked) {
            cleanupLock(el)
            setupLock(el, binding)
        }
    },

    unmounted(el) {
        if(el.__licenseWatchStop) {
            el.__licenseWatchStop()
            el.__licenseWatchStop = null
        }
        cleanupLock(el)
    }
}
